// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import CollapsibleContainer from '@tcp/core/src/components/common/molecules/CollapsibleContainer';
import StoreAddressTile from '@tcp/core/src/components/common/molecules/StoreAddressTile';
import { propTypes } from '@tcp/core/src/components/common/molecules/StoreAddressTile/views/prop-types';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import style, { collapsibleStyles, tileStyles } from '../styles/StoreLocations.style';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import {
  StoreLocatorLabels,
  STORE_DETAILS_LABELS,
} from '../../../../features/storeLocator/Labels/StoreLocator.labels';

export const CollapsibleLocations = withStyles(CollapsibleContainer, collapsibleStyles);
export const LocationTile = withStyles(StoreAddressTile, tileStyles);

class StoreLocations extends PureComponent {
  constructor(props) {
    super(props);
    this.storeDetailsLabels = getLabelFromCopyOrFromTranslation(
      STORE_DETAILS_LABELS,
      StoreLocatorLabels
    );
  }

  getCollapsibleHeader() {
    return (
      <BodyCopy
        className="collapsible-header-text"
        fontSize="fs12"
        component="span"
        fontWeight="extrabold"
        color="text.primary"
      >
        {renderLabel(
          this.storeDetailsLabels.lbl_storedetails_locations_title,
          'lbl_storedetails_locations_title'
        )?.toLowerCase()}
      </BodyCopy>
    );
  }

  getCollapsibleContent() {
    const { stores, children } = this.props;
    return (
      <div className="collapsible-content">
        {stores.map((store) => this.getAddressTitle(store))}
        {children}
      </div>
    );
  }

  getAddressTitle(store) {
    const {
      labels,
      openStoreDetails,
      type,
      isStoreDetailsDesktopRedesignEnabled,
      isStsCtaEnabled,
      isShopThisStoreEnabled,
      updateStore,
      isStoreDetailsRedesignMobileEnabled,
      fromStoreDetailPage,
    } = this.props;
    const tileLabels = {
      ...labels,
      lbl_storelanding_getdirections_link: renderLabel(
        this.storeDetailsLabels.lblStoredetailsLocationsDetailsBtn,
        'lbl_storedetails_locations_details_btn'
      ),
    };
    return (
      <LocationTile
        labels={tileLabels}
        store={store}
        isPageTitle
        openStoreDirections={(event) => openStoreDetails(event, store)}
        locatorGetDirections="open-store-details"
        type={type}
        isStoreDetailsDesktopRedesignEnabled={isStoreDetailsDesktopRedesignEnabled}
        isStoreDetailsRedesignMobileEnabled={isStoreDetailsRedesignMobileEnabled}
        isStsCtaEnabled={isStsCtaEnabled}
        isShopThisStoreEnabled={isShopThisStoreEnabled}
        updateStore={updateStore}
        fromStoreDetailPage={fromStoreDetailPage}
      />
    );
  }

  render() {
    const {
      children,
      className,
      stores,
      isStoreDetailsRedesignMobileEnabled,
      isStoreDetailsDesktopRedesignEnabled,
    } = this.props;

    return (
      <div className={className}>
        <div className="location__lg">
          <BodyCopy
            className="locations-title"
            fontSize="fs16"
            component="h2"
            fontWeight="extrabold"
          >
            {renderLabel(
              this.storeDetailsLabels.lbl_storedetails_locations_title,
              'lbl_storedetails_locations_title'
            )?.toLowerCase()}
          </BodyCopy>
          <Row fullBleed className={isStoreDetailsDesktopRedesignEnabled && 'other-stores'}>
            {Array.isArray(stores) &&
              stores?.map((store) => (
                <Col
                  key={store.basicInfo.storeName}
                  colSize={{ small: 6, medium: 4, large: 3 }}
                  className={isStoreDetailsDesktopRedesignEnabled && 'other-stores-item'}
                >
                  {this.getAddressTitle(store)}
                </Col>
              ))}
          </Row>
        </div>
        <div className="location__sm">
          <CollapsibleLocations
            header={this.getCollapsibleHeader()}
            body={this.getCollapsibleContent()}
            isMobileOtherLoactions={isStoreDetailsRedesignMobileEnabled}
            isCollapseDisabled={isStoreDetailsRedesignMobileEnabled}
            defaultOpen={isStoreDetailsRedesignMobileEnabled}
          />
        </div>

        {children}
      </div>
    );
  }
}

StoreLocations.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.node),
  stores: PropTypes.arrayOf(PropTypes.shape(propTypes.store)),
  openStoreDetails: PropTypes.func,
  type: PropTypes.string,
  fromStoreDetailPage: PropTypes.bool,
};

StoreLocations.defaultProps = {
  children: null,
  stores: [],
  openStoreDetails: null,
  type: '',
  fromStoreDetailPage: false,
};

export default withStyles(StoreLocations, style);
